"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PriceClassificationsBinding_1 = require("./PriceClassificationsBinding");
/**
 * Class represents competitor price
 *
 * @author RV
 * @author Jaroslav Sevcik
 */


var CompetitorPrice =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompetitorPrice, _DomainObject_1$Domai);

  /**
   * @param id
   * @param dataUploadId
   * @param date date, when was price collected
   * @param flags list of price classifications (PROMO, REGULAR, OUTLIER) by zone
   * @param competitorProductId
   * @param siteId
   * @param value actual price
   * @param regularPrice the price declared as regular by competitors, it is only informative
   * @param city
   * @param isFromWebScraping
   * @param promo flag whether is price promo
   * @param sellout flag whether is price sellout
   */
  function CompetitorPrice(id, dataUploadId, date, flags, competitorProductId, siteId, value, regularPrice, city, isFromWebScraping, promo, sellout) {
    var _this;

    _classCallCheck(this, CompetitorPrice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPrice).call(this));
    _this.id = id;
    _this.dataUploadId = dataUploadId;
    _this.date = date;
    _this.flags = flags;
    _this.competitorProductId = competitorProductId;
    _this.siteId = siteId;
    _this.value = value;
    _this.regularPrice = regularPrice;
    _this.city = city;
    _this.isFromWebScraping = isFromWebScraping;
    _this.promo = promo;
    _this.sellout = sellout;
    return _this;
  }

  _createClass(CompetitorPrice, [{
    key: "getExternalClassification",
    value: function getExternalClassification() {
      return this.sellout || this.promo ? PriceClassificationsBinding_1.PriceClassification.Promo : PriceClassificationsBinding_1.PriceClassification.Regular;
    }
  }]);

  return CompetitorPrice;
}(DomainObject_1.DomainObject);

exports.CompetitorPrice = CompetitorPrice;

CompetitorPrice.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompetitorPrice.name);
  return {
    id: builder.str('id'),
    dataUploadId: builder.str('dataUploadId'),
    date: builder.date('date', DateParser_1.DateParser.ISO_PATTERN),
    flags: builder.listOf(builder.obj(PriceClassificationsBinding_1.PriceClassificationsBinding.name, PriceClassificationsBinding_1.PriceClassificationsBinding.schema, function (mat) {
      return new PriceClassificationsBinding_1.PriceClassificationsBinding(mat.autoFlag, mat.userFlag, mat.externalFlag, mat.priceZoneId);
    })),
    competitorProductId: builder.str('competitorProductId'),
    siteId: builder.str('siteId'),
    value: builder.bigNum('value'),
    regularPrice: builder.opt(builder.bigNum('regularPrice')),
    city: builder.opt(builder.str('city')),
    promo: builder.bool('promo'),
    sellout: builder.opt(builder.bool('sellout')),
    isFromWebScraping: builder.bool('isFromWebScraping')
  };
}();